import { RaceParticipant } from "./ticket-apuestas.model";

export interface StraightMLineItem {
  Amount: number;
  AmountLocal: number;
  CanBeEachWay: boolean;
  downOdd: boolean;
  EventDate: string;
  EventHasHandicap: boolean;
  EventId: string;
  EventName: string;
  GameBetTypeAvailability: number;
  GameId: string;
  GameLocked: boolean;
  GameName: string;
  GameSpecialOddsValue: string;
  GreyhoundHorseBetType: unknown;
  GreyhoundHorses: boolean;
  Handicap: boolean;
  Index: number;
  IsBanked: boolean;
  IsBet: boolean;
  IsLive: boolean;
  ItemId?: number;
  LeagueId?: string;
  LineErrorMessages: string[];
  LineErrors: string[];
  LineItemStatus: number;
  LiveStatus: boolean;
  LocationId?: string;
  Paddock: string;
  Participants: RaceParticipant[];
  PendingCheck: boolean;
  PipelineExecutionResult: number;
  Name: string;
  NodeId: string;
  NotAvailable: boolean;
  Odd: number;
  Place: number;
  ResultName: string;
  ResultsNr: string;
  Selected: boolean;
  SportHandle: string;
  SpecialOddsValue: string;
  TicketNumber: string;
  TotalPotentialWin?: number;
  upOdd: boolean;
}
